import { useEffect, useState } from 'react';
import { withConnectHost } from '@atlassian/jira-connect-utils/src/common/utils/ecosystem-connect-host.tsx';
import { useExperienceStart } from '@atlassian/jira-experience-tracker/src/ui/experience-start/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { CONNECT_APP_EXPERIENCE_ID } from './constants.tsx';

type LoadConnectJsResult = {
	loading: boolean;
	error?: Error;
};

export const useLoadConnectJs = (shouldLoad: boolean): LoadConnectJsResult => {
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState<unknown>(undefined);
	useEffect(() => {
		if (shouldLoad) {
			withConnectHost(() => {
				setIsLoading(false);
			}).catch((e) => {
				setIsLoading(false);
				setError(e);
			});
		}
	}, [shouldLoad]);

	return {
		loading: isLoading,
		// @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'Error | undefined'.
		error,
	};
};

export const useConnectAppExtensionExperienceStart = (hasConnectApps: boolean) => {
	const cloudId = useCloudId();
	const onStart = useExperienceStart({
		experience: CONNECT_APP_EXPERIENCE_ID,
		experienceId: cloudId,
		analyticsSource: 'versionDetails',
	});

	useEffect(() => {
		if (hasConnectApps) {
			onStart();
		}
	}, [onStart, hasConnectApps]);
};
